import { useQuery } from '@tanstack/react-query';

import { usePermissions } from '@/components/providers/PermissionsContextProvider';
import { Feature } from '@/components/shared/constants/features';

import { getApplicantAssignees } from '../endpoints/applicantAssignees';
import { retryServerOutages } from '../retry';
import { FOCUS_STALE_TIME_MS } from './staleTime';

export const useApplicantAssignees = (
    applicantId: string,
    options?: { refetchInterval?: number | false },
) => {
    // assignee.list is granted through ViewApplicant; without it every poll is a 403.
    const { hasFeature } = usePermissions();

    return useQuery({
        queryKey: ['applicant-assignees', applicantId],
        staleTime: FOCUS_STALE_TIME_MS,
        queryFn: () => getApplicantAssignees(applicantId),
        enabled: !!applicantId && hasFeature(Feature.ViewApplicant),
        refetchInterval: options?.refetchInterval ?? false,
        refetchIntervalInBackground: false,
        retry: retryServerOutages,
    });
};
